/** Базовый URL API: env → относительный /api на проде → localhost в dev. */
export function getApiBase() {
  const fromEnv =
    typeof process !== "undefined" && process.env.REACT_APP_API_URL;
  if (fromEnv) return String(fromEnv).replace(/\/$/, "");

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host && host !== "localhost" && host !== "127.0.0.1") {
      return "/api";
    }
  }

  return "http://localhost:3005/api";
}

/** Origin для статики /api/files (без суффикса /api). */
export function getApiOrigin() {
  return getApiBase().replace(/\/api\/?$/, "") || "";
}
